/* eslint-disable import/no-anonymous-default-export */
export default () => {
    return localStorage.getItem('userToken')
  }
  